import { useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import UploadFile from "components/Dropzone/UploadFile";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import useLogs from "hooks/logs";
import UtilsFncs from "utils/UtilsFncs";

export default function DialogUploadGerarLinkAWS({
  open,
  onClose,
  isMobile,
  typeForm,
  selectedRow,
  refresh,
}) {
  const { setLocalStorageApiProblem } = useLogs();
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [importando, setImportando] = useState(false);
  const snackbar = useSnackbar();
  const contentRef = useRef(null);

  const handleRefresh = () => {
    setFilesToUpload([]);
    refresh();
  };

  const handleDeleteFile = async () => {
    try {
      const res = await Api.delete(
        "delete-document",
        "conteudo",
        {
          idDocumento: selectedRow?.IdDocumentoArea.toString(),
          tipoMidia: selectedRow?.TipoMidia.toString(),
          local: "ECO",
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage(`Arquivo excluído com sucesso!`, {
          severity: "success",
        });
        onClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "149",
        screen: "Gerar link AWS",
        problem: `Erro na chamada do endpoint delete-document - ${error}`,
      });
    } finally {
      setImportando(false);
    }
  };

  const handleSendData = async () => {
    const fileName = filesToUpload[0]?.name;
    const index = fileName.lastIndexOf(".");
    const fileExtension = fileName.substring(index + 1);

    setImportando(true);

    try {
      const base64Csv = await UtilsFncs.FileToB64(filesToUpload[0]);
      let encodedBase64 = base64Csv?.toString()?.replace(/^data:(.*,)?/, "");

      if (encodedBase64.length % 4 > 0) {
        encodedBase64 += "="?.repeat(4 - (encodedBase64.length % 4));
      }

      const res = await Api.post(
        "create-document",
        "conteudo",
        {
          arquivo: encodedBase64 ? encodedBase64 : "",
          titulo: fileName,
          tipo: "ECOMMERCE",
          descricao: "Link para AWS",
          extensao: fileExtension,
          tipoMidia: "MIDIA",
          local: "ECO",
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage("Documento cadastrado com sucesso.", {
          severity: "success",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
        autoHideDuration: 5000,
      });
      setLocalStorageApiProblem({
        idMenuAccess: "149",
        screen: "Gerar link AWS",
        problem: `Erro na chamada do endpoint create-document - ${error}`,
      });
    } finally {
      setImportando(false);
      onClose();
      handleRefresh();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            {`${
              typeForm === "remove"
                ? "Excluir link AWS"
                : "Enviar vídeo para gerar link AWS"
            }`}
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent ref={contentRef}>
        <>
          {typeForm === "create" ? (
            <>
              <FormLabel required>Arquivo</FormLabel>
              <UploadFile
                accept={[".png", ".jpg", ".mp4", ".mp3"]}
                onChangeFiles={setFilesToUpload}
                disabled={importando}
              />
              {importando && (
                <>
                  <br />
                  <div>
                    <span>Cadastrando documento...</span>
                    <LinearProgress />
                  </div>
                </>
              )}
            </>
          ) : null}
          {typeForm === "remove" ? (
            <Typography id="alert-dialog-description" variant="h4">
              Confirmar exclusão do arquivo?
            </Typography>
          ) : null}
        </>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: isMobile && "center" }}
      >
        <Button component={Box} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={typeForm === "remove" ? handleDeleteFile : handleSendData}
          disabled={
            importando || (typeForm === "create" && filesToUpload.length === 0)
          }
          color="default"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
